import * as Yup from 'yup';

export const medicineManagementValidators = Yup.object().shape({
  name: Yup.string().required('* Campo obrigatório'),
  franchiseId: Yup.string().required('* Campo obrigatório'),
});
